import React from "react";
import { Link } from "react-router-dom";
import Container from "../components/common/Container";
import Button from "../components/common/Button";

const NotFound = () => {
  return (
    <section className="flex min-h-[70vh] items-center bg-white">
      <Container>
        <div className="mx-auto max-w-xl text-center">
          <span className="text-sm font-semibold uppercase tracking-widest text-blue-600">
            404 Error
          </span>

          <h1 className="mt-4 text-4xl font-bold text-slate-900">
            Page not found
          </h1>

          <p className="mt-4 text-slate-600 leading-relaxed">
            Sorry, the page you are looking for doesn’t exist or has been moved.
          </p>

          <div className="mt-8 flex justify-center gap-4">
            <Link to="/">
              <Button>Go Home</Button>
            </Link>

            <Link to="/contact">
              <Button variant="outline">Contact Us</Button>
            </Link>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default NotFound;
